<template>
  <div>
    <b-row>
      <b-col>
        <header-view
          :title="$t('message.adminContractPartnerList.title')"
          icon="ti-agenda">
        </header-view>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <b-card
          class="rounded-0"
          :title="$t('message.adminContractPartnerList.card.title.contractPartners')">
          <b-table
            striped
            hover
            responsive
            :fields="fields"
            :items="contractPartners">
            <template slot="address" slot-scope="data">
              <address>
                <div>{{ data.item.street }} {{ data.item.streetNumber }}</div>
                <div>
                  <span v-if="data.item.postalCode">{{ data.item.postalCode }}</span>
                  <span v-else="data.item.postOfficeBox">{{ data.item.postOfficeBox }}</span>
                  {{ data.item.city }}
                </div>
                <div>{{ data.item.country}}</div>
              </address>
            </template>
            <template slot="actions" slot-scope="data">
              <div class="d-flex flex-row">
                <b-btn
                  variant="link"
                  class="ml-auto btn-action"
                  @click="showDetails(data)">
                  <span class="ti-files"></span>
                </b-btn>
              </div>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <b-card
          class="rounded-0"
          :title="$t('message.adminContractPartnerList.card.title.contractPartnerTemplates')">
          <b-table
            striped
            hover
            responsive
            :fields="fields"
            :items="contractPartnerTemplates">
            <template slot="address" slot-scope="data">
              <address>
                <div>{{ data.item.street }} {{ data.item.streetNumber }}</div>
                <div>
                  <span v-if="data.item.postalCode">{{ data.item.postalCode }}</span>
                  <span v-else="data.item.postOfficeBox">{{ data.item.postOfficeBox }}</span>
                  {{ data.item.city }}
                </div>
                <div>{{ data.item.country}}</div>
              </address>
            </template>
            <template slot="actions" slot-scope="data">
              <div class="d-flex flex-row">
                <div class="ml-auto">
                  <b-btn
                    variant="link"
                    class="btn-action"
                    @click="showContractPartnerTemplate(data)">
                    <span class="ti-pencil-alt"></span>
                  </b-btn>
                </div>
              </div>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import HeaderView from '@/components/common/HeaderView'
  export default {
    name: 'AdminContractPartnerList',
    components: {
      HeaderView
    },
    computed: {
      contractPartners () {
        return this.$store.getters.adminContractPartnerList
      },
      contractPartnerTemplates () {
        return this.$store.getters.adminContractPartnerTemplateList
      }
    },
    created () {
      this.$store.dispatch('fetchAdminContractPartnerList')
      this.$store.dispatch('fetchAdminContractPartnerTemplateList')
    },
    data () {
      return {
        fields: [{
          key: 'contractPartnerName',
          label: this.$t('message.adminContractPartnerList.table.name')
        }, {
          key: 'email',
          label: this.$t('message.adminContractPartnerList.table.email')
        }, {
          key: 'domain',
          label: this.$t('message.adminContractPartnerList.table.domain')
        }, {
          key: 'address',
          label: this.$t('message.adminContractPartnerList.table.address')
        }, {
          key: 'isApprovedByAdmin',
          label: this.$t('message.adminContractPartnerList.table.approved'),
          formatter: (value) => {
            if (value) {
              return this.$t('message.adminContractPartnerList.yes')
            }
            return this.$t('message.adminContractPartnerList.no')
          }
        }, {
          key: 'actions',
          label: ''
        }]
      }
    },
    methods: {
      showDetails (data) {
        this.$router.push(`/admin/contractpartners/${data.item.id}`)
      },
      showContractPartnerTemplate (data) {
        this.$router.push(`/admin/contractpartners/template/${data.item.id}`)
      }
    }
  }
</script>

<style scoped>
  .btn-action {
    text-decoration: none;
  }

  .btn-action:hover {
    color: #21272d;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminContractPartnerList.vue